export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14353.9733b7c9.jpg";